import { getActionType, TYPES } from '../util/redux';
import { ResourceType } from '../action/resource';

/**
 *  
 */
const initState = {
    request0: true,
    request1: true,
    request2: true,
    resourceData: [],
    taskData: {},
    msg0: '',
    msg1: '',
    msg2: '',
    financeAuthority: false
}

// const type1 = getActionType(ResourceType, 'request0');
// const type2 = getActionType(ResourceType, 'request1');
const type1 = getActionType(ResourceType, 'success');
const type2 = getActionType(ResourceType, 'fail');
const type3 = getActionType(ResourceType, 'tasksuccess');
const type4 = getActionType(ResourceType, 'taskfail');
const type5 = getActionType(ResourceType, 'whitelistsuccess');
const type6 = getActionType(ResourceType, 'whitelistfail');
const type7 = getActionType(ResourceType, 'resourceuse');

 
export default function resourceReducer(state = initState, action){
    let { type, payload } = action;
    switch(type){
        case type1:
            // 请求成功
            return {
                ...state,
                request0: false,
                msg0: '',
                resourceData: payload.data,
            }
        case type2:
            // 请求失败
            return {
                ...state,
                request0: false,
                msg0: payload.msg
            }
        case type3:
            // 请求成功
            return {
                ...state,
                request1: false,
                msg1: '',
                taskData: payload.data,
            }
        case type4:
            // 请求失败
            return {
                ...state,
                request1: false,
                msg1: payload.msg
            }
        case type5:
            return {
                ...state,
                request2: false,
                whiteList: payload.data,
                msg2: ''
            }
        case type6:
            return {
                ...state,
                request2: false,
                msg2: payload.msg
            }
        case type7: 
            let { index, use } = payload;
            let tdata = state.resourceData;
            let rdata = tdata[index];
            rdata.remain = rdata.remain - use;
            rdata.used = rdata.used + use;
            tdata[index] = rdata;
            return {
                ...state,
                resourceData: tdata
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/resource.js